export default "__VITE_PUBLIC_ASSET__8e43aa68__"